// fetchShortLink.js
'use strict';
import 'isomorphic-fetch';
import { getHeaders } from '../resource/fetchOptionHeader.js';
import getResourceUrl from '../resource/getResourceUrl.js';
import handleFetchError from '../resource/handleFetchError.js';
import getNetworkingData from '../selector/getNetworkingData.js';

import {
  SET_NETWORKING_FETCHING,
  SET_NETWORKING_SUCCESS,
  SET_NETWORKING_ERROR,
  ADD_SHORT_LINKS,
} from '../ActionTypes.js';

/**
 * Fetch short link
 * @kind action
 * @param {string} {location} - href should be shortened.
 * @param {boolean} {shouldIncludeQueries} - should include queries.
 * @param {object} {utmQueries} - utm queries.
 * @return {Promise} Action promise.
 */
const fetchShortLink =
  ({ location, shouldIncludeQueries, utmQueries = {} } = {}) =>
  async (dispatch, getState) => {
    const networkingSelectPath = ['shortLink', location];
    const isFetching = getNetworkingData(
      getState(),
      networkingSelectPath,
      'isFetching'
    );

    if (!location || isFetching) {
      return { type: '' };
    }

    const locationUrlObj = new URL(location);
    if (!shouldIncludeQueries) {
      [...locationUrlObj.searchParams.keys()].forEach(key =>
        locationUrlObj.searchParams.delete(key)
      );
    }
    const fetchOptions = {
      method: 'GET',
      headers: {
        ...getHeaders(),
      },
    };
    const url = getResourceUrl({ endpoint: '/share' });
    url.searchParams.append('url', locationUrlObj.href);
    Object.keys(utmQueries).map(key => {
      url.searchParams.set(key, utmQueries[key]);
    });

    dispatch({
      type: SET_NETWORKING_FETCHING,
      payload: { selectPath: networkingSelectPath },
    });
    try {
      const response = await fetch(url.href, fetchOptions);

      if (!response.ok) {
        await handleFetchError({ response });
      }

      const shortLink = response.headers.get('location');

      dispatch({
        type: ADD_SHORT_LINKS,
        payload: {
          shortLink: {
            [location]: shortLink,
          },
        },
      });
      return dispatch({
        type: SET_NETWORKING_SUCCESS,
        payload: { selectPath: networkingSelectPath },
      });
    } catch (error) {
      return dispatch({
        type: SET_NETWORKING_ERROR,
        payload: { selectPath: networkingSelectPath, error },
      });
    }
  };

export default fetchShortLink;
